import { useQuery } from '@tanstack/react-query';
import { AvailableCommissionsFilter, getAvailableCommissions } from 'config/requests/gatewayRules';
import { Commission } from 'types/embedded/commission';

type ReturnValues = {
  commissions?: Partial<Commission>[];
  isLoadingCommissions: boolean;
};

type Params = {
  filter: AvailableCommissionsFilter;
  enabled: boolean;
};

export function useGetAvailableCommissions({ filter, enabled }: Params): ReturnValues {
  const { data: commissions, isLoading: isLoadingCommissions } = useQuery({
    queryKey: [
      'commission/available_to_implement',
      filter.currency,
      filter.merchant,
      filter.gateways,
      filter.currency,
      filter.transactionTypes,
    ],
    queryFn: () => getAvailableCommissions(filter),
    enabled,
  });

  return { commissions, isLoadingCommissions };
}
